(() => {
  if (window.okaCleanUrl) return;
  const unwanted = ['_su_rec', '_su_rec_id'];
  const cleanUrl = (value) => {
    try {
      const url = new URL(value, location.href);
      if (url.origin !== location.origin || !unwanted.some((key) => url.searchParams.has(key))) return value;
      unwanted.forEach((key) => url.searchParams.delete(key));
      return url.href;
    } catch {
      return value;
    }
  };
  window.okaCleanUrl = cleanUrl;
  const cleanAddress = () => {
    const cleaned = cleanUrl(location.href);
    if (cleaned !== location.href) history.replaceState(history.state, '', cleaned);
  };
  const cleanAnchor = (anchor) => {
    const value = anchor.getAttribute('href');
    if (!value) return;
    const cleaned = cleanUrl(value);
    if (cleaned !== value) anchor.setAttribute('href', cleaned);
  };
  const cleanLinks = () => document.querySelectorAll('a[href*="_su_rec"]').forEach(cleanAnchor);
  cleanAddress();
  cleanLinks();
  window.addEventListener('pageshow', cleanAddress);
  window.addEventListener('popstate', cleanAddress);
  document.addEventListener('DOMContentLoaded', cleanLinks, { once: true });
  ['click', 'auxclick', 'contextmenu', 'pointerover', 'focusin'].forEach((type) => {
    document.addEventListener(type, (event) => {
      cleanAddress();
      const anchor = event.composedPath().find((node) => node instanceof HTMLAnchorElement);
      if (anchor) cleanAnchor(anchor);
    }, true);
  });
})();
